module.exports = "/_next/static/images/951a668ef92b39c33adc82e4d9d0129c-hero-xs.jpg.webp";